import React from "react";
import styles from "./Timer.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAlarmClock} from "@fortawesome/pro-solid-svg-icons/faAlarmClock";
import RenderIf from "@/components/Global/RenderIf/RenderIf";

export default function Timer({
  daysRemaining = "",
  hoursRemaining = "",
  minutesRemaining = "",
  secondsRemaining = "",
  className = "",
  faIcon = faAlarmClock,
  faIconClassName = "",
  showUnits = true,
}) {
  return (
    <div className={`${styles.timer} ${className}`}>
      <FontAwesomeIcon icon={faIcon} className={`${styles.clockIcon} fa-fw ${faIconClassName}`} />

      <RenderIf isTrue={daysRemaining !== ""}>
        <div className="col text-center">
          <strong>{daysRemaining}</strong> <span className={`${styles.unit} ${showUnits ? "" : "d-none"}`}>Days</span>
        </div>
        <span className={`col-auto ${styles.timerSeparator}`}>- -</span>
      </RenderIf>

      <RenderIf isTrue={hoursRemaining !== ""}>
        <div className="col text-center">
          <strong>{hoursRemaining?.toString()?.padStart(2, "0")}</strong>{" "}
          <span className={`${styles.unit} ${showUnits ? "" : "d-none"}`}>Hours</span>
        </div>
        <span className={`col-auto ${styles.timerSeparator}`}>- -</span>
      </RenderIf>

      <RenderIf isTrue={minutesRemaining !== ""}>
        <div className="col text-center">
          <strong>{minutesRemaining?.toString()?.padStart(2, "0")}</strong>{" "}
          <span className={`${styles.unit} ${showUnits ? "" : "d-none"}`}>Mins</span>
        </div>
      </RenderIf>

      <RenderIf isTrue={secondsRemaining !== ""}>
        <span className={`col-auto ${styles.timerSeparator}`}>- -</span>
        <div className="col text-center">
          <strong>{secondsRemaining?.toString()?.padStart(2, "0")}</strong>{" "}
          <span className={`${styles.unit} ${showUnits ? "" : "d-none"}`}>Secs</span>
        </div>
      </RenderIf>
    </div>
  );
}
